import React from "react";
import "./Radio.css";

import RadioButtonActive from "../../assets/radial-filter-button-ON.svg";

export const RadioActive = () => {
  return (
    <img
      className="delicious100-interactive__radio-button"
      src={RadioButtonActive}
      alt="RadioButtonActive"
    ></img>
  );
};
